import { FunctionComponent, useEffect } from 'react';
import GoogleAnalytics from 'react-ga4';
import { useLocation } from 'react-router-dom';
import { GoogleAnalyticsId } from '../../config/Config';

export const Analytics: FunctionComponent = () => {
  const location = useLocation();

  useEffect(() => {
    GoogleAnalytics.initialize(GoogleAnalyticsId);
  }, []);

  useEffect(() => {
    GoogleAnalytics.send('pageview');
  }, [location]);

  return null;
};
